import React from 'react';
import ModelsInfoCard from './../SlideoutCards/ModelsInfoCard';
import ModelsSettingsCard from './../SlideoutCards/ModelsSettingsCard';
import { string, func, object, array, number, shape, bool } from 'prop-types';
import ActionableHeaderCard from 'ps-components/Card/ActionableHeaderCard';

StructureBulkCopyBody.propTypes = {
  slideout: object,
  groups: array,
  permissions: object,
  modelInfoProps: shape({
    name: string,
    setName: func,
    scopeValue: string,
    setScopeValue: func,
    description: string,
    setDescription: func,
    namePosition: string,
    setNamePosition: func,
    outputText: string,
    groupList: array,
    setGroupList: func,
    allGroups: bool,
    setAllGroups: func
  }),
  modelSettingsProps: shape({
    buildRange: string,
    setBuildRange: func,
    weightAverage: string,
    setWeightAverage: func,
    midpointAverage: object,
    setMidpointAverage: func,
    rangeSpread: number,
    setRangeSpread: func,
    rounding: object,
    setRounding: func,
    midpointAdjustment: number,
    setMidpointAdjustment: func,
    targetElements: array,
    buildRangeOptions: array,
    roundOptions: array
  })
};

export default function StructureBulkCopyBody(props) {
  const { slideout, groups, modelInfoProps, modelSettingsProps, permissions } = props;

  return (
    <React.Fragment>
      <ActionableHeaderCard
        cardTitle="Models Info"
        className="structure-models-info__card"
        cardTitleClassName="structure-models-info__card-header"
      >
        <ModelsInfoCard slideout={slideout} groups={groups} permissions={permissions} {...modelInfoProps} />
      </ActionableHeaderCard>
      <ActionableHeaderCard
        cardTitle="Model Settings"
        className="structure-models-settings__card"
        cardTitleClassName="structure-models-settings__card-header"
      >
        <ModelsSettingsCard {...modelSettingsProps} />
      </ActionableHeaderCard>
    </React.Fragment>
  );
}
